module.exports = __webpack_public_path__ + "media/images/new_home/product-2-0501a9b4080dd613d2cca3dc4b2587f8.png";